import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.713 19.762l-3.713 1.238v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1","key":"svg-0"}],["path",{"d":"M16 22l5 -5","key":"svg-1"}],["path",{"d":"M21 21.5v-4.5h-4.5","key":"svg-2"}]]

const IconFilterShare = createReactComponent('outline', 'filter-share', 'FilterShare', __iconNode);

export default IconFilterShare;